import { useEffect,useState } from "react";
import modalImage from "../../assests/images/modal-image.webp";
import phoneLogo from "../../assests/images/phone.png";
import mailLogo from "../../assests/images/mail.png";
import { getSupportDetails } from "../../services/apiServices/GetServices";
import { supportModalHeading1 } from "../TextInputUtils";
import { supportModalHeading2 } from "../TextInputUtils";
const SupportModal = () => {

  const [supportData,setSupportData]=useState([])

  useEffect(() => {
    getSupportData()
}, []);

  const getSupportData = async () => {
    try{
        const res = await getSupportDetails("support")
        if (res?.success) {
            setSupportData(res?.data[0])
            
        } else {
            console.log("res", res?.message)
        }
    }catch(error){
        console.log("error",error)
    }
}


    return (
        <div class="d-flex flex-column justify-content-center px-3 pt-4">
            <div class="align-self-center mb-4">
            <img src={modalImage} alt="supportModal-image" class="img-fluid" style={{height: "70px"}}/>
            </div>
            <h5 class="text-center">{supportModalHeading1}</h5>
            <p class="text-center">{supportModalHeading2}</p>
            <div class="d-flex felx-row justify-content-around">
            <div class="p-2 border border-white shadow rounded-4 d-flex flex-row justify-content-around bg-white mb-4 mb-md-0 align-items-center">
            <img src={phoneLogo} alt="phone" class="img-fluid mx-2" style={{widht: "25px", height: "25px"}}/>
            <p class="card-text lg-w-0 text-left mx-md-3 previewColor">+91 {supportData?.phone_number}</p>
          </div>
          <div class="p-2 border border-white shadow rounded-4 d-flex flex-row justify-content-around bg-white align-items-center">
            <img src={mailLogo} alt="phone" style={{widht: "25px", height: "25px"}}/>
            <a href="mailto:someone@example.com"  class="card-text w-75 text-left lg-w-0  mx-md-2 previewColor">{supportData?.email}</a>
          </div>
          </div>
        </div>
    )
}

export default SupportModal